<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="headline">Kommunikasjon</div>

                <v-row>
                    <v-col>
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th width="20%">Type mal</th>
                                    <!-- <th width="70%">Innhold</th> -->
                                    <!-- <th width="10%">Opprettet på</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="emailTemplate in emailTemplates" :key="emailTemplate.id" @click="selectEmailTemplate(emailTemplate)" style="cursor: pointer;" :class="selectedEmailTemplate && emailTemplate.id === selectedEmailTemplate.id? 'grey lighten-2': undefined">
                                    <td>
                                        <div>{{emailTypeText(emailTemplate.type)}}</div>
                                    </td>
                                    <!-- <td>
                                <div>{{emailTemplate.content}}</div>
                            </td> -->
                                    <!-- <th>
                                        <div>{{moment.unix(emailTemplate.createdAt).format("YYYY-MM-DD HH:mm")}}</div>
                                    </th> -->
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                    <v-col>
                        <v-select v-model="selectedCompany" :items="companies" item-text="name" label="Selskap" placeholder="Velg et selskap" return-object></v-select>
                        <v-select v-model="selectedApplication" :items="applications" item-text="name" label="Søknad" placeholder="Velg en søknad" return-object></v-select>
                        <v-select v-model="selectedUser" :items="users" item-text="fullname" label="Bruker" placeholder="Velg en bruker" return-object>
                            <!-- <template v-slot:item="{item}">
                                {{item.firstname}} {{item.lastname}}
                            </template>
                            <template v-slot:selection="{item}">
                                {{item.firstname}} {{item.lastname}}
                            </template> -->
                        </v-select>
                    </v-col>
                </v-row>

                <hr>
                <br>

                <v-row>
                    <v-col class="pa-1">
                        <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
                            <div>
                                <v-btn :class="{ 'is-active': isActive.bold() }" @click="commands.bold" icon>
                                    <v-icon>mdi-format-bold</v-icon>
                                </v-btn>
                                <v-btn :class="{ 'is-active': isActive.italic()}" @click="commands.italic" icon>
                                    <v-icon>mdi-format-italic</v-icon>
                                </v-btn>
                                <v-btn :class="{ 'is-active': isActive.underline()}" @click="commands.underline" icon>
                                    <v-icon>mdi-format-underline</v-icon>
                                </v-btn>
                                <v-btn :class="{ 'is-active': isActive.strike()}" @click="commands.strike" icon>
                                    <v-icon>mdi-format-strikethrough</v-icon>
                                </v-btn>
                                <!-- <v-btn :class="{ 'is-active': isActive.paragraph()}" @click="commands.paragraph" icon>
                                    <v-icon>mdi-format-paragraph</v-icon>
                                </v-btn> -->

                                <v-btn :class="{ 'is-active': isActive.bullet_list()}" @click="commands.bullet_list" icon>
                                    <v-icon>mdi-format-list-bulleted</v-icon>
                                </v-btn>

                                <v-btn :class="{ 'is-active': isActive.ordered_list()}" @click="commands.ordered_list" icon>
                                    <v-icon>mdi-format-list-numbered</v-icon>
                                </v-btn>

                                <v-btn :class="{ 'is-active': isActive.link()}" @click="openLinkDialog('keylink',commands.link)" icon>
                                    <v-icon>mdi-key-link</v-icon>
                                </v-btn>
                                <v-btn :class="{ 'is-active': isActive.link()}" @click="openLinkDialog('link',commands.link)" icon>
                                    <v-icon>mdi-link</v-icon>
                                </v-btn>
                                <!-- <v-btn :class="{ 'is-active': isActive.link()}" @click="commands.link({href:'http://localhost:8082/#/passwordreset/{{token}}'})" icon>
                                    <v-icon>mdi-link</v-icon>
                                </v-btn> -->
                                <v-btn :class="{ 'is-active': isActive.link()}" @click="commands.link({href: null})" icon>
                                    <v-icon>mdi-link-off</v-icon>
                                </v-btn>

                                <v-btn :class="{ 'is-active': isActive.heading()}" @click="commands.heading({level:[1]})" icon>
                                    <v-icon>mdi-format-header-1</v-icon>
                                </v-btn>

                                <v-btn :class="{ 'is-active': isActive.heading()}" @click="commands.heading({level:[2]})" icon>
                                    <v-icon>mdi-format-header-2</v-icon>
                                </v-btn>

                                <v-btn :class="{ 'is-active': isActive.heading()}" @click="commands.heading({level:[3]})" icon>
                                    <v-icon>mdi-format-header-3</v-icon>
                                </v-btn>
                            </div>
                        </editor-menu-bar>
                        <editor-content :editor="editor" :extensions="[]" class="grey lighten-3" />
                    </v-col>
                    <v-col class="pa-1">
                        <div class="d-flex align-center" style="height: 36px;">
                            <div>Forhåndsvisning</div>
                            <v-select v-model="selectedApplication" :items="applications" item-text="name" label="Søknad" return-object class="ml-3"></v-select>

                        </div>
                        <!-- <v-textarea v-html="preview" readonly hide-details flat></v-textarea> -->

                        <div ref="preview" contenteditable="false" class="grey lighten-3 text-wrap" style="min-height: 150px;"></div>
                    </v-col>
                </v-row>

                <v-btn color="green text" :disabled="!selectedEmailTemplate" @click="saveEmailTemplate">
                    <v-icon left>mdi-content-save</v-icon>
                    Lagre mal
                </v-btn>
            </v-col>
        </v-row>

        <v-dialog v-model="linkDialog.show" width="500px">
            <v-card>
                <v-card-title class="white--text" :style="{background: colors().primary1}">
                    Legg til en lenke
                </v-card-title>
                <v-card-text class="pt-5">
                    <v-text-field v-model="linkDialog.ref" label="lenke" placeholder="https://" clearable filled dense hide-details></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="createLink">
                        <v-icon left>mdi-link</v-icon>
                        legg til
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>

</template>

<script>
import * as axios from "axios";
import * as moment from "moment";
import * as handlebars from "handlebars";

import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import { Blockquote, CodeBlock, HardBreak, Heading, OrderedList, BulletList, ListItem, TodoItem, TodoList, Bold, Code, Italic, Link, Strike, Underline, History } from "tiptap-extensions";

export default {
    components: {
        EditorContent,
        EditorMenuBar
    },
    data() {
        return {
            emailTemplates: [],
            selectedEmailTemplate: undefined,
            moment: moment,
            editor: new Editor({
                extensions: [new Blockquote(), new CodeBlock(), new HardBreak(), new Heading({ levels: [1, 2, 3] }), new BulletList(), new OrderedList(), new ListItem(), new TodoItem(), new TodoList(), new Bold(), new Code(), new Italic(), new Link(), new Strike(), new Underline(), new History()],
                content: `
            <p>Velg en mal...</p>
            `
            }),

            applications: [],
            selectedApplication: undefined,

            companies: [],
            selectedCompany: [],

            users: [],
            selectedUser: undefined,
            linkDialog: {
                show: false,
                ref: undefined,
                linkCommandFunction: undefined,
                type: undefined
            }
        };
    },
    methods: {
        openLinkDialog(typeOfLink, linkCommandFunction) {
            this.linkDialog.type = typeOfLink;
            this.linkDialog.linkCommandFunction = linkCommandFunction;

            if (this.linkDialog.type === "keylink") {
                this.createLink();
            } else {
                this.linkDialog.show = true;
            }
        },
        createLink() {
            // commands.link({href:'http://localhost:8082/#/passwordreset/{{token}}'})

            if (this.linkDialog.type === "keylink") {
                this.linkDialog.linkCommandFunction({ href: `${window.location.origin}/#/passwordreset/{{token}}` });
            } else {
                this.linkDialog.linkCommandFunction({ href: this.linkDialog.ref });
            }

            this.linkDialog.show = false;
            this.linkDialog.ref = undefined;
            this.linkDialog.linkCommandFunction = undefined;
        },
        selectEmailTemplate: function(emailTemplate) {
            if (this.selectedEmailTemplate !== emailTemplate) {
                this.selectedEmailTemplate = emailTemplate;
                this.editor.setContent(emailTemplate?.content);
            } else {
                this.selectedEmailTemplate = undefined;
                this.editor.clearContent();
            }
        },
        saveEmailTemplate: async function() {
            this.selectedEmailTemplate.content = this.editor.getHTML();
            let response = await axios.put("/emailtemplate", { emailTemplate: this.selectedEmailTemplate });

            let index = this.emailTemplates.findIndex(et => et.id === this.selectedEmailTemplate.id);
            if (index > -1) {
                this.emailTemplates.splice(index, 1, response.data);
            }
        },
        realtimePreviewContentUpdate(htmlContent) {
            if (htmlContent) {
                try {
                    let compiledHandlerbarsTemplate = handlebars.compile(htmlContent);
                    let injectedHtml = compiledHandlerbarsTemplate({
                        user: this.selectedUser,
                        company: this.selectedCompany,
                        application: this.selectedApplication,
                        time: {
                            text: moment().format("YYYY-MM-DD HH:mm"),
                            time: moment().format("HH:mm"),
                            year: moment().year(),
                            month: moment().month() + 1,
                            week: moment().week(),
                            day: moment().date()
                        }
                    });

                    this.$refs.preview.innerHTML = injectedHtml;
                } catch (error) {
                    (() => {})(error);
                }
            } else {
                this.$refs.preview.innerHTML = "";
            }
        }
    },
    watch: {
        "selectedEmailTemplate.content": function(content) {
            this.realtimePreviewContentUpdate(content);
        },
        selectedCompany: async function() {
            if (this.selectedCompany) {
                this.applications = this.selectedCompany.applications;
                this.users = this.selectedCompany.users.map(u => {
                    u.fullname = `${u.firstname} ${u.lastname}`;
                    return u;
                });

                if (this.selectedApplication && !this.applications.some(a => a.id === this.selectedApplication.id)) {
                    this.selectedApplication = undefined;
                }
            } else {
                this.applications = [];
                this.selectedApplication = undefined;

                this.users = [];
                this.selectedUser = undefined;
            }
            this.realtimePreviewContentUpdate(this.selectedEmailTemplate?.content);
        },
        selectedApplication: async function() {
            this.realtimePreviewContentUpdate(this.selectedEmailTemplate?.content);
        },
        selectedUser: function() {
            this.realtimePreviewContentUpdate(this.selectedEmailTemplate?.content);
        }
    },
    async mounted() {
        let response = await axios.get("/emailtemplate");
        this.emailTemplates = response.data;

        this.companies = await this.$store.dispatch("fetchCompanies", { include: "[applications,users]" });

        this.editor.on("update", ({ getHTML }) => {
            this.realtimePreviewContentUpdate(getHTML());
        });
    },
    beforeDestroy() {
        this.editor.destroy();
    }
};
</script>

<style lang="scss">
.ProseMirror {
    min-height: 150px;
}
</style>